const RefreshSocketClient = require('./RefreshSocketClient');

const client = new RefreshSocketClient();
client.connect();